import { render, staticRenderFns } from "./ImgSwiperBlock.vue?vue&type=template&id=63275713&scoped=true"
import script from "./ImgSwiperBlock.vue?vue&type=script&lang=js"
export * from "./ImgSwiperBlock.vue?vue&type=script&lang=js"
import style0 from "../index.css?vue&type=style&index=0&id=63275713&prod&scoped=true&lang=css&external"
import style1 from "./ImgSwiperBlock.vue?vue&type=style&index=1&id=63275713&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63275713",
  null
  
)

export default component.exports